import axios from 'axios';
import { deleteAllCookies, getCookie } from './Utils';
import { reloadWindow } from 'gfdu';

const ApiCall = axios.create({
    baseURL: 'https://api.madrasselfdrivecars.com',
    // baseURL: 'http://localhost:5006',
    timeout: 20000,
    headers: { 'Content-Type': 'application/json' }
});
ApiCall.interceptors.request.use(
    (config) => {
        const token = getCookie('token');
        if (token) { config.headers.Authorization = `Bearer ${token}`; }
        if(config.formData){
            config.headers['Content-Type'] = 'multipart/form-data'   
        }
        return config;
    },
    (error) => { return Promise.reject(error); }
);
ApiCall.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
            deleteAllCookies()
        }
        return Promise.reject(error);
    }
);

export default ApiCall;